// extracted by mini-css-extract-plugin
module.exports = {"notificationBox":"styles_notificationBox__2YGKs","icon":"styles_icon__tsj5A"};